export default __webpack_public_path__ + "assets/onboarding-screen.589af03f.svg";